import { Href } from 'expo-router';

import { PostInfo } from '@/components/md-blog';

export type DataType = {
  title: string;
  description: string;
  value: string;
  href: Href;
  series?: string;
  coverImage: string;
};

export function loadPosts(contextRequire: any) {
  const posts = contextRequire
    .keys()
    .filter((i: string) => i.match(/\.js$/))
    .map((key: string) => contextRequire(key));

  return posts
    .map(
      ({
        title,
        shortTitle,
        subtitle,
        date,
        slug,
        series,
        featuredImage,
      }: PostInfo) => ({
        title: shortTitle ?? title,
        description: subtitle,
        value: new Date(date).toLocaleDateString('en-US', {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
        }),
        date,
        href: `/articles/${slug}`,
        series,
        coverImage: featuredImage,
      })
    )
    .sort((a: PostInfo, b: PostInfo) => b.date.localeCompare(a.date));
}
